module.exports = __webpack_public_path__ + "static/media/settings_close.4c2f6079.svg";